import { render, staticRenderFns } from "./AppQuestion5.vue?vue&type=template&id=373ce3c8&"
import script from "./AppQuestion5.vue?vue&type=script&lang=js&"
export * from "./AppQuestion5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports